/* eslint-disable */
import React, { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import { HighlightOff as CancelIcon, Delete as Trash } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { Box, Grid, makeStyles, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuid, validate } from 'uuid';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import _ from 'lodash';
import QCXFormStepWizard from '../../shared-components/form-step-wizard/QCXFormStepWizard';
import QCXFinalFormDataReplicator from '../form-data-replicator/QCXFinalFormDataReplicator';
import QCXTabsManager from '../tabs/QCXTabsManager';
import QCXRelacaoFornecedorFieldGroup from '../relacao-fornecedor/QCXRelacaoFornecedorFieldGroup';
import { fetchAdicoesByDiDuimpIdAsync } from '../../features/declaracao-importacao/declaracaoImportacaoThunks';
import {
  loading,
  setModel,
  resetStatus,
  resetAdicoes,
} from '../../features/declaracao-importacao/declaracaoImportacaoSlice';
import QCXSelectCoberturaCambialAutocomplete from '../../shared-components/select-cobertura-cambial/QCXSelectCoberturaCambialAutocomplete';
import QCXSelectMotivoImportacaoSemCoberturaCambialAutocomplete from '../../shared-components/select-motivo-importacao-sem-cobertura-cambial/QCXSelectMotivoImportacaoSemCoberturaCambialAutocomplete';
import QCXSelectVinculoCompradorVendedorAutocomplete from '../../shared-components/select-vinculo-comprador-vendedor/QCXSelectVinculoCompradorVendedorAutocomplete';
import QCXSelectCFOPOperacoesFiscaisAutocomplete from '../../shared-components/final-autocomplete-select-cfop-operacoes-fiscais-field/QCXSelectCFOPOperacoesFiscaisAutocomplete';
import QCXFinalSelectAplicacaoMercadoriaAutocomplete from '../../shared-components/select-aplicacao-mercadoria/QCXFinalSelectAplicacaoMercadoriaAutocomplete';
import QCXSelectCondicaoVendaAutocomplete from '../../shared-components/select-condicao-venda/QCXSelectCondicaoVendaAutocomplete';
import QCXSelectIncotermCondicaoVendaAutocomplete from '../../shared-components/final-select-incoterm-condicao-venda-field/QCXSelectIncotermCondicaoVendaAutocomplete';
import QCXSelectMetodoValoracaoAutocomplete from '../../shared-components/select-metodo-valoracao/QCXSelectMetodoValoracaoAutocomplete';
import QCXFinalTextField from '../../shared-components/final-text-field/QCXFinalTextField';
import QCXFinalCheckboxField from '../../shared-components/final-checkbox-field/QCXFinalCheckboxField';
import QCXAtributosFundamentoLegalDuimpFormGroup from '../../shared-components/atributos-fundamento-legal-duimp-form-group/QCXAtributosFundamentoLegalDuimpFormGroup';
import QCXAtributosTratamentoTributarioDuimp from '../../shared-components/atributos-tratamento-tributario-duimp/QCXAtributosTratamentoTributarioDuimp';
import QCXFormSubtitle from '../form-title/QCXFormSubtitle';
import QCXFinalAlternativeCurrencyField from '../../shared-components/final-currency-field/QCXFinalAlternativeCurrencyField';
import QCXSelectInstituicaoFinanciadoraAutocomplete from '../../shared-components/select-instituicao-financiadora/QCXSelectInstituicaoFinanciadoraAutocomplete';
import QCXFormTitle from '../form-title/QCXFormTitle';
import {
  configureGeneralRegimeTributacaoMatcherWith,
  configureSpecificRegimeTributacaoSuspensaoMatcher,
  REGIME_TRIBUTACAO_IMUNIDADE_CODE,
  REGIME_TRIBUTACAO_NAO_INCIDENCIA_CODE,
} from '../../shared-components/select-regime-tributacao/regimeTributacaoUtils';
import { setErrorFeedback, setSuccessFeedback } from '../../features/feedback/feedbackSlice';
import QCXIICommonFormGroup from '../../shared-components/ii-form-group/QCXIICommonFormGroup';
import QCXIPICommonFormGroup from '../../shared-components/ipi-form-group/QCXIPICommonFormGroup';
import QCXPisCofinsCommonFormGroup from '../../shared-components/pis-cofins-form-group/QCXPisCofinsCommonFormGroup';
import QCXIcmsCommonFormGroup from '../../shared-components/icms-form-group/QCXIcmsCommonFormGroup';
import {
  selectRegimesTributacao,
  fetchAllAsync as fetchAllRegimeTributacaoAsync,
} from '../../features/regime-tributacao/regimeTributacaoSlice';

import { fetchAsyncAtributosTratamentosTributarios } from '../../features/tratamento-tributario/tratamentoTributarioThunks';

import useOperationMiddleware from '../../utils/hooks/operation/middleware/useOperationMiddleware';
import QCXConfirmDialog from '../../shared-components/dialog/QCXConfirmDialog';

import { normalizeNumeral, normalizeYear } from '../../utils/general/general-utils';
import {
  TIPO_ACRESCIMO,
  TIPO_DEDUCAO,
} from '../../shared-components/select-tipo-acrescimo-deducao/tipoAcrescimoDeducaoUtils';

import { parseToBoolean } from '../../utils/general/parse-utils';
import {
  COBERTURA_CAMBIAL_COM_COBERTURA_180_360_DIAS,
  COBERTURA_CAMBIAL_COM_COBERTURA_ACIMA_360_DIAS,
  COBERTURA_CAMBIAL_COM_COBERTURA_ATE_180_DIAS,
  COBERTURA_CAMBIAL_SEM_COBERTURA,
  isCoberturaCambialComCoberturaAcima360Dias,
  isCoberturaCambialSemCobertura,
  isSomeCoberturaCambial,
} from '../../shared-components/select-cobertura-cambial/coberturaCambialUtils';
import {
  configureGeneralTipoDeclaracaoMatcherWith,
  getSuggestiveValues,
  TIPO_DECLARACAO_ADMISSAO_EM_ALC_AREA_DE_LIVRE_COMERCIO,
  TIPO_DECLARACAO_ADMISSAO_EM_DAD_DEPOSITO_ADUANEIRO_DE_DISTRIBUICAO,
  TIPO_DECLARACAO_ADMISSAO_EM_DE_DAF,
  TIPO_DECLARACAO_ADMISSAO_EM_EIZOF_ENTREPOSTO_INTERNACIONAL_DA_ZFM,
  TIPO_DECLARACAO_ADMISSAO_EM_ENTREPOSTO_ADUANEIRO,
  TIPO_DECLARACAO_ADMISSAO_EM_ENTREPOSTO_INDUSTRIAL,
  TIPO_DECLARACAO_ADMISSAO_EM_LOJA_FRANCA,
  TIPO_DECLARACAO_ADMISSAO_NA_ZFM_ZONA_FRANCA_DE_MANAUS,
  TIPO_DECLARACAO_ADMISSAO_TEMPORARIA,
  TIPO_DECLARACAO_INTERNACAO_DA_ZFM_PE_PRODUTO_ESTRANGEIRO,
  TIPO_DECLARACAO_INTERNACAO_DA_ZFM_PI_PRODUTO_INDUSTRIALIZADO,
  TIPO_DECLARACAO_INTERNACAO_DE_ALC_AREA_DE_LIVRE_COMERCIO,
  TIPO_DECLARACAO_SAIDA_DE_ENTREPOSTO_INDUSTRIAL,
  TIPO_DECLARACAO_DUIMP,
} from '../../shared-components/select-tipo-declaracao/tipoDeclaracaoUtils';

import {
  selectMotivosImportacaoSemCoberturaCambial,
  fetchAllAsync as fetchAllMotivosImportacaoSemCoberturaCambialAsync,
} from '../../features/motivo-importacao-sem-cobertura-cambial/motivoImportacaoSemCoberturaCambialSlice';
import { selectTiposDeclaracao } from '../../features/tipo-declaracao/tipoDeclaracaoSlice';
import { useFornecedorListenersGroup } from '../relacao-fornecedor/relacao-fornecedor-utils';
import useIpiCommonFormGroupListeners from '../../shared-components/ipi-form-group/ipiCommonFormGroupListeners';
import QCXSelectPortoAeroportoAutocomplete from '../../shared-components/select-porto-aeroporto/QCXSelectPortoAeroportoAutocomplete';
import QCXFinalNumericIntegerField from '../../shared-components/final-numeric-integer-field/QCXFinalNumericIntegerField';

import QCXIIFormGroup from '../../shared-components/ii-form-group/QCXIIFormGroup';
import { BRAZILIAN } from '../../utils/hooks/form/field/mask-types';
import QCXIPIFormGroup from '../../shared-components/ipi-form-group/QCXIPIFormGroup';
import QCXPisCofinsFormGroup from '../../shared-components/pis-cofins-form-group/QCXPisCofinsFormGroup';
import QCXAntidumpingFormGroup from '../../shared-components/antidumping-form-group/QCXAntidumpingFormGroup';
import QCXAFRMMFormGroup from '../../shared-components/afrmm-form-group/QCXAFRMMFormGroup';
import QCXSisComexFormGroup from '../../shared-components/siscomex-form-group/QCXSisComexFormGroup';
import QCXIcmsFormGroup from '../../shared-components/icms-form-group/QCXIcmsFormGroup';
import QCXFinalAtributoNveBondManagerManyAdicoes from './QCXFinalAtributoNveBondManagerManyAdicoes';
import { normalizeAtributosDinamicosNcm } from '../fatura/mercadoriaUtils';

import { selectIsLoading } from '../../features/tratamento-tributario/tratamentoTributarioSelectors';

import QCXProgressBackdrop from '../../shared-components/backdrop/QCXProgressBackdrop';

import QCXButton from '../../shared-components/button/QCXButton';

import InputWithCleanButton from './inputWithCleanButton/InputWithCleanButton';

import { setIsLimparCamposActive } from '../../features/limpar-campos-state/limparCamposSlice';
import { selectStale } from '../../features/declaracao-importacao/declaracaoImportacaoSelectors';
import QCXCircularProgress from '../../shared-components/progress/QCXCircularProgress';
import { doPutQCXRequest } from '../../utils/api/domain/domain-api-utils';
import QCXIBSFormGroup from '../../shared-components/ibs-form-group/QCXIBSFormGroup';
import QCXCBSFormGroup from '../../shared-components/cbs-form-group/QCXCBSFormGroup';
import QCXFaturaAtributosNcmDinamico from '../fatura/QCXFaturaAtributosNcmDinamico';
import QCXSelectManyFundamentosOpcionais from './adicoesForm/components/QCXSelectManyFundamentosOpcionais';
import { fetchTributosTtceByNcmPais } from '../../features/ncm-subitem/ncmSubitemAPI';
import QCXSelectManyFundamentosObrigatorios from './adicoesForm/components/QCXSelectManyFundamentosObrigatorios';
import { useForm } from 'react-final-form';
import TributosMercadoriaDuimp from './components/TributosMercadoriaDuimp';

const useStyles = makeStyles((theme) => ({
  gridField: {
    paddingBottom: '16px',
  },
  checkboxGridField: {
    paddingBottom: '8px',
  },
  leftSiblingGridField: {
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '16px',
    },
    [theme.breakpoints.up('md')]: {
      paddingLeft: '8px',
    },
  },
  rightSiblingGridField: {
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '16px',
    },
    [theme.breakpoints.up('md')]: {
      paddingRight: '8px',
    },
  },
  sibling: {
    [theme.breakpoints.down('sm')]: {
      paddingTop: '8px',
      marginTop: '8px',
    },
    [theme.breakpoints.up('md')]: {
      paddingLeft: '8px',
    },
  },
}));

export default function QCXDeclaracaoImportacaoAuxiliarDUIMPImpostosForm({
  values,
  submitSucceeded,
  parentModel,
  isDuimp = true,
  isConsult,
  idFatura,
}) {
  /* TRATAMENTOS TRIBUTARIOS */
  const form = useForm();

  const { t } = useTranslation();
  const classes = useStyles();

  const [ncmSelecionado, setNcmSelecionado] = useState(null);
  const [idPais, setIdPais] = useState(null);
  const [tributos, setTributos] = useState([]);
  const [tributosLoading, setTributosLoading] = useState(false);

  const [fundamentosObrigatorios, setFundamentosObrigatorios] = useState([]);
  const [fundamentosOpcionaisGrouped, setFundamentosOpcionaisGrouped] = useState([]);

  const obterIdPaisByMercadoria = useCallback((mercadoria) => {
    let pais = null;
    const relacao = _.get(mercadoria, 'relacao', null);
    const exportadorPais =
      _.get(mercadoria, 'exportador.endereco.cidade.estado.pais.id', null) ??
      _.get(mercadoria, 'exportador.endereco.estado.pais.id', null) ??
      _.get(mercadoria, 'exportador.endereco.pais.id', null);
    const fabricantePais =
      _.get(mercadoria, 'fabricante.endereco.cidade.estado.pais.id', null) ??
      _.get(mercadoria, 'fabricante.endereco.estado.pais.id', null) ??
      _.get(mercadoria, 'fabricante.endereco.pais.id', null);

    if (relacao === 'FABRICANTE_EXPORTADOR') {
      pais = exportadorPais;
    } else if (relacao === 'FABRICANTE_NAO_EXPORTADOR') {
      pais = fabricantePais;
    } else if (relacao === 'FABRICANTE_DESCONHECIDO') {
      pais = _.get(mercadoria, 'paisOrigem.id', null);
    }

    return pais;
  }, []);

  const itensSelecionados = values?.meta?.selected ?? [];

  useEffect(() => {
    if (!itensSelecionados || !Array.isArray(itensSelecionados)) {
      setNcmSelecionado(null);
      setIdPais(null);
    }

    const ncmsSelecionados = {};
    itensSelecionados.forEach((it) => {
      if (it?.ncm?.id) {
        ncmsSelecionados[it.ncm.id] = it.ncm;
      }
    });

    const idNcmsSelecionados = Object.keys(ncmsSelecionados);
    const idPaisesSelecionados = Array.from(new Set(itensSelecionados.map(obterIdPaisByMercadoria)));

    if (idNcmsSelecionados.length === 1 && idPaisesSelecionados.length === 1) {
      setNcmSelecionado(ncmsSelecionados[idNcmsSelecionados[0]]);
      setIdPais(idPaisesSelecionados[0]);

      form.change('ignorableFields.repassarTratamentosTributarios', true);
    } else {
      setNcmSelecionado(null);
      setIdPais(null);

      form.change('ignorableFields.repassarTratamentosTributarios', false);
    }
  }, [itensSelecionados, obterIdPaisByMercadoria]);

  const normalizeMetadados = (codTratamento, mercadorias) => {
    if (!mercadorias || !Array.isArray(mercadorias)) {
      return { atributosUnicos: {}, combinacoesValidas: [] };
    }

    const mapperAtributos = {};
    const combinacoesValidas = [];

    mercadorias.forEach((mercadoria) => {
      const atributos = mercadoria?.atributos || [];

      const combinacao = atributos.map((attr) => ({
        codigo: attr?.codigo,
        valor: attr?.valor,
      }));

      combinacoesValidas.push(combinacao);

      atributos.forEach((atributo) => {
        const codigo = atributo?.codigo || '';

        if (mapperAtributos[codigo]) {
          if (atributo?.tipoCodigo === 'Domínio dinâmico') {
            const jaExiste = mapperAtributos[codigo].dominio.some((d) => d.valor === atributo?.valor);

            if (!jaExiste) {
              mapperAtributos[codigo].dominio.push({
                valor: atributo?.valor,
                descricao: atributo?.descricaoValor,
              });
            }
          }
        } else {
          const newAtributo = {
            codigo: atributo?.codigo || '',
            descricaoCodigo: atributo?.descricaoCodigo || '',
            tipoCodigo: atributo?.tipoCodigo || '',
            codTratamento,
            dominio: [],
          };

          if (atributo?.tipoCodigo === 'Domínio dinâmico') {
            newAtributo.dominio.push({
              valor: atributo?.valor,
              descricao: atributo?.descricaoValor,
            });
          }

          mapperAtributos[codigo] = newAtributo;
        }
      });
    });

    return {
      atributosUnicos: mapperAtributos,
      combinacoesValidas,
    };
  };

  const agruparFundamentos = (fundamentosMetadadosArr) => {
    if (!fundamentosMetadadosArr) return [];

    const fundamentos = {};

    fundamentosMetadadosArr.forEach((item) => {
      const codigoFundamento = item.fundamentoLegal.codigo;
      const nomeFundamento = item.fundamentoLegal.nome;
      const tipoFundamento = item.fundamentoLegal.tipo;

      if (!fundamentos[codigoFundamento]) {
        fundamentos[codigoFundamento] = {
          id: codigoFundamento,
          nome: nomeFundamento,
          tipo: tipoFundamento,
          tratamentos: [],
        };
      }

      fundamentos[codigoFundamento].tratamentos.push({
        regime: {
          codigo: item?.regime?.codigo,
          nome: item?.regime?.nome,
        },
        tributo: {
          codigo: item?.tributo?.codigo,
          nome: item?.tributo?.nome,
        },
      });
    });

    const fundamentosParsed = Object.values(fundamentos).map((fundamento) => ({ ...fundamento }));
    const fundamentosOrdenados = fundamentosParsed.sort((a, b) => a.id.localeCompare(b.id));

    return fundamentosOrdenados;
  };

  useEffect(() => {
    if (ncmSelecionado?.id && idPais) {
      setTributosLoading(true);

      fetchTributosTtceByNcmPais(ncmSelecionado?.id, idPais)
        .then((response) => {
          const responseData = response?.data || {};
          const tratamentosObrigatorios = _.isArray(responseData?.tratamentosTributarios)
            ? responseData.tratamentosTributarios
            : [];
          const tratamentosOpcionaisDisponiveis = _.isArray(responseData?.fundamentosOpcionaisDisponiveis)
            ? responseData.fundamentosOpcionaisDisponiveis
            : [];

          if (tratamentosOpcionaisDisponiveis.length) {
            const fundamentosOrdenados = agruparFundamentos(tratamentosOpcionaisDisponiveis);
            setFundamentosOpcionaisGrouped(fundamentosOrdenados);
          }

          if (tratamentosObrigatorios.length) {
            // agrupa fundamentos obrigatorios para exibicao
            const fundamentosOrdenados = agruparFundamentos(tratamentosObrigatorios);
            setFundamentosObrigatorios(fundamentosOrdenados);
          }

          const tratamentosParaMetadados = [...tratamentosObrigatorios, ...tratamentosOpcionaisDisponiveis];

          if (tratamentosParaMetadados.length) {
            // normaliza metadados de campos relacionados a tratamentos tributarios
            const atributosValores = {};
            const atributosNormalizados = [];
            const todasCombinacoesValidas = {};

            tratamentosParaMetadados.forEach((tratamento) => {
              const codTratamento = `${tratamento?.tributo?.codigo};${tratamento?.regime?.codigo};${tratamento?.fundamentoLegal?.codigo}`;

              const { atributosUnicos: atributosObj, combinacoesValidas } = normalizeMetadados(
                codTratamento,
                tratamento.mercadorias
              );

              todasCombinacoesValidas[codTratamento] = combinacoesValidas;
              const valoresPreenchidos = _.get(values, 'valoresMetadadoTtce.valorMetadadosJson', {});

              const valoresFields = {};
              const gruposPreenchidos = ['obrigatorios', 'opcionais'];

              gruposPreenchidos.forEach((grupo) => {
                const grupoValores = valoresPreenchidos?.[grupo];
                if (!grupoValores) return;

                Object.entries(grupoValores).forEach(([key, value]) => {
                  if (value?.atributos && _.isArray(value?.atributos)) {
                    value.atributos.forEach((atributo) => {
                      valoresFields[`${atributo.codigo}`] = atributo.valor;
                    });
                  }
                });
              });

              Object.entries(atributosObj).forEach(([key, value]) => {
                const hasValor = Object.prototype.hasOwnProperty.call(valoresFields, key);

                let prevCodTratamentosPossiveis = [];
                if (key in atributosValores) {
                  prevCodTratamentosPossiveis = atributosValores[key]?.codTratamentosPossiveis ?? [];
                }
                atributosValores[key] = {
                  ...value,
                  valor: hasValor ? valoresFields[key] : '',
                  codTratamentosPossiveis: [...prevCodTratamentosPossiveis, value?.codTratamento],
                };
                atributosNormalizados.push(value);
              });
            });

            form.change(
              'ignorableFields.tratamentosTtce.metadados.valores',
              atributosValores // objeto react-final-form
            );

            responseData.metadadosNormalizados = atributosNormalizados;
            responseData.combinacoesValidas = todasCombinacoesValidas;
          }

          setTributos(responseData || []);
        })
        .catch((error) => {
          console.log('err', error);
          setTributos([]);
        })
        .finally(() => {
          setTributosLoading(false);
        });
    } else {
      setFundamentosObrigatorios([]);
      setFundamentosOpcionaisGrouped([]);
      setFundamentosObrigatorios([]);
      setTributos([]);
    }
  }, [ncmSelecionado, idPais]);

  const obterCodigoTratamento = useCallback((tratamento) => {
    const fundamentoCodigo =
      tratamento?.fundamentoLegal?.codigo ?? tratamento?.fundamento?.id ?? tratamento?.fundamento?.codigo;
    return `${tratamento?.tributo?.codigo};${tratamento?.regime?.codigo};${fundamentoCodigo}`;
  }, []);

  const tributosFiltrados = useMemo(() => {
    console.log('trib ', tributos);

    const metadadosNormalizados = tributos?.metadadosNormalizados || [];
    const combinacoesValidas = tributos?.combinacoesValidas || {};
    const tratamentosObrigatorios = tributos?.tratamentosTributarios || [];
    const tratamentosOpcionaisDisponiveis = tributos?.fundamentosOpcionaisDisponiveis || [];
    const tratamentosOpcionaisSelecionados = _.get(values, 'ignorableFields.tratamentosTtce.metadados.opcionais', []);

    const codigosObrigatorios = new Set(tratamentosObrigatorios.map(obterCodigoTratamento));
    const codigosOpcionaisDisponiveis = new Set(tratamentosOpcionaisDisponiveis.map(obterCodigoTratamento));
    const codigosOpcionaisSelecionados = new Set(tratamentosOpcionaisSelecionados.map(obterCodigoTratamento));

    const metadadosPermitidos = metadadosNormalizados.filter((metadado) => {
      const codTratamento = metadado?.codTratamento;
      if (codigosObrigatorios.has(codTratamento)) return true;
      if (codigosOpcionaisDisponiveis.has(codTratamento)) return codigosOpcionaisSelecionados.has(codTratamento);
      return true;
    });

    const metadadosFiltrados = metadadosPermitidos.reduce((acc, metadado) => {
      const codigo = metadado?.codigo;
      if (!codigo) return acc;
      if (!acc.find((item) => item.codigo === codigo)) {
        acc.push(metadado);
      }
      return acc;
    }, []);

    const codigosPermitidos = new Set(metadadosFiltrados.map((metadado) => metadado?.codTratamento));
    const combinacoesFiltradas = Object.keys(combinacoesValidas).reduce((acc, cod) => {
      if (codigosPermitidos.has(cod)) {
        acc[cod] = combinacoesValidas[cod];
      }
      return acc;
    }, {});

    return {
      ...tributos,
      metadadosNormalizados: metadadosFiltrados,
      combinacoesValidas: combinacoesFiltradas,
    };
  }, [tributos, values, obterCodigoTratamento]);

  const modes = { isConsult };

  const regimesTributacao = useSelector(selectRegimesTributacao);
  const tiposDeclaracao = useSelector(selectTiposDeclaracao);
  const motivosImportacaoSemCoberturaCambial = useSelector(selectMotivosImportacaoSemCoberturaCambial);
  const tipoDeclaracao = useMemo(() => parentModel?.atributosAdicionais?.tipoDeclaracao, [parentModel]);

  const isSomeTipoDeclaracaoBy = useCallback(
    (codesToCompare) => configureGeneralTipoDeclaracaoMatcherWith(tiposDeclaracao)(tipoDeclaracao?.id, codesToCompare),
    [tiposDeclaracao, tipoDeclaracao]
  );

  const getRegimeTributacaoIIFrom = useCallback((values) => values?.ii?.regimeTributacao?.id, []);

  const isSomeRegimeTributacaoIIBy = useCallback(
    (values, codesToCompare) =>
      configureGeneralRegimeTributacaoMatcherWith(regimesTributacao)(getRegimeTributacaoIIFrom(values), codesToCompare),
    [getRegimeTributacaoIIFrom, regimesTributacao]
  );

  const isRegimeTributacaoIISuspensaoBy = useCallback(
    (values) => configureSpecificRegimeTributacaoSuspensaoMatcher(regimesTributacao)(getRegimeTributacaoIIFrom(values)),
    [getRegimeTributacaoIIFrom, regimesTributacao]
  );

  return (
    <Grid item container spacing={2}>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <QCXFormSubtitle title="Tratamentos Opcionais" />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12}>
        <QCXSelectManyFundamentosOpcionais
          title="Fundamentos Opcionais"
          name="ignorableFields.tratamentosTtce.metadados.opcionais"
          values={values}
          disabled={isConsult}
          configureFilterPredicate={(item) => true}
          fundamentosOpcionaisGrouped={fundamentosOpcionaisGrouped}
          idFatura={idFatura}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12}>
        <QCXFormSubtitle title="Tratamentos Obrigatorios" />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12}>
        <QCXSelectManyFundamentosObrigatorios
          title="Fundamentos Obrigatorios"
          name="ignorableFields.tratamentosTtce.metadados.obrigatorios"
          values={values}
          disabled={isConsult}
          configureFilterPredicate={(item) => true}
          fundamentosGrouped={fundamentosObrigatorios}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12}>
        <QCXAtributosTratamentoTributarioDuimp
          name="ignorableFields.tratamentosTtce.metadados.valores"
          modes={modes}
          metadados={tributosFiltrados}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12}>
        <QCXFaturaAtributosNcmDinamico defaultNcmOnly defaultNcm={ncmSelecionado} modes={modes} codObjetivo={5} />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12}>
        <QCXFormTitle title={'Atributos de Fundamento Legal DUIMP'.toUpperCase()} />
      </Grid>
      <QCXAtributosFundamentoLegalDuimpFormGroup modes={modes} />
      {/*
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <TributosMercadoriaDuimp disabled={isConsult} />
        </Grid>
      */}

      <Grid
        item
        style={{
          paddingTop: '0px',
        }}
        xs={12}
        sm={12}
        md={12}
        lg={12}
      >
        <QCXFormTitle
          title={t('com.muralis.qcx.imposto.II')}
          boxProps={{
            pt: 0,
          }}
        />
      </Grid>
      <QCXIIFormGroup
        intl={BRAZILIAN}
        modes={modes}
        submitSucceeded={submitSucceeded}
        parentModel={parentModel}
        isDuimp={isDuimp}
        forceShowAcordos
      />

      <Grid item xs={12} sm={12} md={12} lg={12}>
        <QCXFormTitle title={'Atributos de Fundamento Legal DUIMP'.toUpperCase()} />
      </Grid>
      <QCXAtributosFundamentoLegalDuimpFormGroup
        intl={BRAZILIAN}
        modes={modes}
        parentModel={parentModel}
        submitSucceeded={submitSucceeded}
      />
      <QCXAtributosTratamentoTributarioDuimp
        intl={BRAZILIAN}
        modes={modes}
        parentModel={parentModel}
        submitSucceeded={submitSucceeded}
        isRepasse
      />

      {!isSomeRegimeTributacaoIIBy(values, [REGIME_TRIBUTACAO_IMUNIDADE_CODE, REGIME_TRIBUTACAO_NAO_INCIDENCIA_CODE]) &&
        !isSomeTipoDeclaracaoBy([
          TIPO_DECLARACAO_INTERNACAO_DA_ZFM_PI_PRODUTO_INDUSTRIALIZADO,
          TIPO_DECLARACAO_INTERNACAO_DA_ZFM_PE_PRODUTO_ESTRANGEIRO,
        ]) && (
          <>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <QCXFormTitle title={t('com.muralis.qcx.imposto.IPI')} />
            </Grid>
            <QCXIPIFormGroup
              intl={BRAZILIAN}
              modes={modes}
              parentModel={parentModel}
              submitSucceeded={submitSucceeded}
              isDuimp={isDuimp}
            />
          </>
        )}
      {!isSomeTipoDeclaracaoBy([
        TIPO_DECLARACAO_INTERNACAO_DA_ZFM_PI_PRODUTO_INDUSTRIALIZADO,
        TIPO_DECLARACAO_INTERNACAO_DA_ZFM_PE_PRODUTO_ESTRANGEIRO,
      ]) && (
        <>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <QCXFormTitle title={t('com.muralis.qcx.legislacao.PISCOFINS')} />
          </Grid>
          <QCXPisCofinsFormGroup
            intl={BRAZILIAN}
            modes={modes}
            parentModel={parentModel}
            submitSucceeded={submitSucceeded}
          />
        </>
      )}
      {!isSomeTipoDeclaracaoBy([
        TIPO_DECLARACAO_INTERNACAO_DA_ZFM_PI_PRODUTO_INDUSTRIALIZADO,
        TIPO_DECLARACAO_INTERNACAO_DA_ZFM_PE_PRODUTO_ESTRANGEIRO,
      ]) && (
        <>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <QCXFormTitle title={t('com.muralis.qcx.exportacao.antidumping')} />
          </Grid>
          <QCXAntidumpingFormGroup intl={BRAZILIAN} modes={modes} submitSucceeded={submitSucceeded} />
        </>
      )}
      {!isSomeTipoDeclaracaoBy([
        TIPO_DECLARACAO_INTERNACAO_DA_ZFM_PI_PRODUTO_INDUSTRIALIZADO,
        TIPO_DECLARACAO_INTERNACAO_DA_ZFM_PE_PRODUTO_ESTRANGEIRO,
      ]) &&
        (parentModel?.followUp?.servico?.viaTransporte?.code === '01' ||
          parentModel?.followUp?.servico?.viaTransporte?.code === '02' ||
          parentModel?.followUp?.servico?.viaTransporte?.code === '03') && (
          <>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <QCXFormTitle title={t('com.muralis.qcx.frete.AFRMM')} />
            </Grid>
            <QCXAFRMMFormGroup intl={BRAZILIAN} modes={modes} submitSucceeded={submitSucceeded} />
          </>
        )}
      {!isSomeTipoDeclaracaoBy([
        TIPO_DECLARACAO_INTERNACAO_DA_ZFM_PI_PRODUTO_INDUSTRIALIZADO,
        TIPO_DECLARACAO_INTERNACAO_DA_ZFM_PE_PRODUTO_ESTRANGEIRO,
      ]) && (
        <>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <QCXFormTitle title={t('com.muralis.qcx.taxaSiscomex')} />
          </Grid>
          <QCXSisComexFormGroup intl={BRAZILIAN} modes={modes} submitSucceeded={submitSucceeded} />
        </>
      )}

      <>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <QCXFormTitle title={t('com.muralis.qcx.multaLi.label')} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <InputWithCleanButton>
            <QCXFinalCheckboxField
              name="multaLi.calculaMultaLi"
              label={t('com.muralis.qcx.multaLi.calculaMultaLi')}
              disabled={isConsult}
            />
          </InputWithCleanButton>
        </Grid>
        {values?.multaLi?.calculaMultaLi && (
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <InputWithCleanButton>
              <QCXFinalCheckboxField
                name="multaLi.multaPossuiReducao"
                label={t('com.muralis.qcx.multaLi.comReducao')}
                disabled={isConsult}
              />
            </InputWithCleanButton>
          </Grid>
        )}
        {values?.multaLi?.calculaMultaLi && (
          <Grid item xs={12} sm={6} md={6} lg={6} style={{ paddingTop: '2vh' }}>
            <QCXFinalAlternativeCurrencyField
              id="valor-devido-reais-tarifario-field-icms"
              key="valor-devido-reais-tarifario-field-icms"
              name="multaLi.valorDevidoReal"
              label={t('com.muralis.qcx.valorDevidoReais')}
              adorned
              disabled
            />
          </Grid>
        )}
        {values?.multaLi?.calculaMultaLi && (
          <Grid item xs={12} sm={6} md={6} lg={6} style={{ paddingTop: '2vh' }}>
            <QCXFinalAlternativeCurrencyField
              id="valor-recolher-reais-tarifario-field-icms"
              key="valor-recolher-tarifario-field-icms"
              name="multaLi.valorRecolherReal"
              label={t('com.muralis.qcx.valorRecolherReais')}
              adorned
              disabled
            />
          </Grid>
        )}
      </>

      {!isSomeTipoDeclaracaoBy([
        TIPO_DECLARACAO_INTERNACAO_DA_ZFM_PI_PRODUTO_INDUSTRIALIZADO,
        TIPO_DECLARACAO_INTERNACAO_DA_ZFM_PE_PRODUTO_ESTRANGEIRO,
      ]) && (
        <>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <QCXFormTitle title="IBS" />
          </Grid>
          <QCXIBSFormGroup
            intl={BRAZILIAN}
            modes={modes}
            parentModel={parentModel}
            submitSucceeded={submitSucceeded}
            paraRepasseAuxiliar
          />
        </>
      )}

      {!isSomeTipoDeclaracaoBy([
        TIPO_DECLARACAO_INTERNACAO_DA_ZFM_PI_PRODUTO_INDUSTRIALIZADO,
        TIPO_DECLARACAO_INTERNACAO_DA_ZFM_PE_PRODUTO_ESTRANGEIRO,
      ]) && (
        <>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <QCXFormTitle title="CBS" />
          </Grid>
          <QCXCBSFormGroup
            intl={BRAZILIAN}
            modes={modes}
            parentModel={parentModel}
            submitSucceeded={submitSucceeded}
            paraRepasseAuxiliar
          />
        </>
      )}

      {!isSomeTipoDeclaracaoBy([
        TIPO_DECLARACAO_INTERNACAO_DA_ZFM_PI_PRODUTO_INDUSTRIALIZADO,
        TIPO_DECLARACAO_INTERNACAO_DA_ZFM_PE_PRODUTO_ESTRANGEIRO,
      ]) && (
        <>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <QCXFormTitle title={t('com.muralis.qcx.ICMS.label')} />
          </Grid>
          <QCXIcmsFormGroup
            intl={BRAZILIAN}
            modes={modes}
            parentModel={parentModel}
            submitSucceeded={submitSucceeded}
          />
        </>
      )}
    </Grid>
  );
}
